import { gitnum } from 'gitnum';
import React from 'react';
import { Navbar } from 'react-bootstrap';
import './footer.scss';

/** Λεπτομέρειες έκδοσης — κλικ στο version (desktop & mobile) */
const showVersionDetails = () => {
  window.location.reload();
  alert(
    'Έκδοση: ' +
      gitnum.describe +
      '\nBuild:  ' +
      gitnum.git +
      '\nBranch: ' +
      gitnum.branch +
      '\nCommit: ' +
      gitnum.commit +
      '\nDate:   ' +
      gitnum.date,
  );
};

const Footer = () => (
  <footer>
    <Navbar className="app-footer justify-content-between" bg="dark" variant="dark" fixed="bottom">
      {/* Desktop — τρεις στήλες */}
      <div className="app-footer__desktop d-none d-sm-flex w-100 justify-content-between align-items-center">
        <Navbar.Text className="p-0">
          <small>
            <a href="https://www.rebattery.gr/" target="_blank" rel="noopener noreferrer">
              Φωτοκύκλωση
            </a>{' '}
            {new Date().getFullYear()}
          </small>
        </Navbar.Text>
        <Navbar.Text className="p-0">
          <small>
            created by{' '}
            <a href="http://www.motion.gr" target="_blank" rel="noopener noreferrer">
              Motion Hellas Ltd.
            </a>{' '}
          </small>
        </Navbar.Text>
        <Navbar.Text className="p-0">
          <span className="app-footer__version" onClick={showVersionDetails}>
            <small>
              <span className="app-footer__version-label">Έκδοση</span> {gitnum.version}
            </small>
          </span>
        </Navbar.Text>
      </div>

      {/* Mobile — μία σύντομη γραμμή */}
      <Navbar.Text className="app-footer__mobile d-sm-none p-0 mx-auto text-center">
        <small>
          <a href="https://www.rebattery.gr/" target="_blank" rel="noopener noreferrer">
            Φωτοκύκλωση
          </a>{' '}
          <a href="http://www.motion.gr" target="_blank" rel="noopener noreferrer">
            Motion Hellas Ltd.
          </a>{' '}
          <span className="app-footer__version" onClick={showVersionDetails}>
            {gitnum.version}
          </span>
        </small>
      </Navbar.Text>
    </Navbar>
  </footer>
);

export default Footer;
